import { render, staticRenderFns } from "./ViewCandidatesBody.vue?vue&type=template&id=a7bbe2f4&scoped=true"
import script from "./ViewCandidatesBody.vue?vue&type=script&lang=ts"
export * from "./ViewCandidatesBody.vue?vue&type=script&lang=ts"
import style0 from "./ViewCandidatesBody.vue?vue&type=style&index=0&id=a7bbe2f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bbe2f4",
  null
  
)

export default component.exports